// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2vvVH","content":"GlobalSearch_content__2ugEI"};